module.exports = __webpack_public_path__ + "img/stena25.a890bc7c.jpg";